import { useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
import {
  selectAllChats,
  selectChatsCount,
  virtualHumanTalkingSelector,
} from '../../../slices/chat/ChatSlice';
import useUser from '../../../../../core/src/helpers/useUser';

export const useDispatchAIGenerationSurveyStartEvent = (
  isPreviewPlayer,
  virtualHumanDataSS
) => {
  const { ID: userID } = useUser();
  const virtualHumanTalking = useSelector(virtualHumanTalkingSelector);
  const chats = useSelector(selectAllChats);
  const latestChatIsBot =
    chats.length > 0 && chats[chats.length - 1].chatType === 'bot';

  const botChatCount = useMemo(() => {
    return chats.filter((chat) => chat.chatType === 'bot').length;
  }, [chats]);

  useEffect(() => {
    // increment bot chats
    if (
      isPreviewPlayer &&
      botChatCount >= 5 &&
      virtualHumanDataSS?.AuthorID === userID &&
      virtualHumanDataSS?.CreationMethod === 'ai_create' &&
      !virtualHumanTalking // not sure this check is working as intended but will fix if it's brought up as an issue
    ) {
      var event = new CustomEvent('showAIGenerationSurvey');
      window.parent.document.dispatchEvent(event);
    }
  }, [
    chats,
    isPreviewPlayer,
    latestChatIsBot,
    userID,
    virtualHumanDataSS?.AuthorID,
    virtualHumanDataSS?.CreationMethod,
    virtualHumanTalking,
    botChatCount,
  ]);
};
